module.exports = __webpack_public_path__ + "static/media/SolutionPage_Shadow@2x.ca54c505.png";